import { render, staticRenderFns } from "./my-header.vue?vue&type=template&id=55d3b620&scoped=true"
import script from "./my-header.vue?vue&type=script&lang=js"
export * from "./my-header.vue?vue&type=script&lang=js"
import style0 from "./my-header.vue?vue&type=style&index=0&id=55d3b620&prod&scoped=true&lang=scss"
import style1 from "./my-header.vue?vue&type=style&index=1&id=55d3b620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3b620",
  null
  
)

export default component.exports